import React, { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import Btn from "../Btn/index";
import "./styles.scss";

const navItems = [
	{ label: "inicio", url: "/", page: "" },
	{ label: "servicios", url: "/servicios", page: "servicios" },
	{ label: "oficinas", url: "/oficinas", page: "oficinas" },
	{ label: "contacto", url: "/contacto", page: "contacto" },
	{ label: "nosotros", url: "/nosotros", page: "nosotros" },
	{ label: "aliados", url: "/aliados", page: "aliados" },
];

const menuVariants = {
	hidden: { x: "100%", opacity: 0 },
	visible: {
		x: 0,
		opacity: 1,
		transition: { duration: 0.28, ease: "easeOut" },
	},
	exit: {
		x: "100%",
		opacity: 0,
		transition: { duration: 0.2, ease: "easeIn" },
	},
};

const Navbar = ({ actualPage }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [isScrolled, setIsScrolled] = useState(false);
	const shouldReduceMotion = useReducedMotion();

	useEffect(() => {
		const handleScroll = () => {
			setIsScrolled(window.pageYOffset > 12);
		};

		handleScroll();
		window.addEventListener("scroll", handleScroll, { passive: true });

		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	const closeMenu = () => setIsOpen(false);
	const navClassName = isScrolled ? "nav nav_with_scroll" : "nav";

	return (
		<nav className={navClassName} id="nav">
			<div className="menuNormal">
				<Link to="/" onClick={closeMenu} className="brand_link" aria-label="ForzaKargo inicio">
					<img className="img1" alt="ForzaKargo" src="/images/logo-p.png" />
					<img className="img2" alt="ForzaKargo" src="/images/logo-p-blanco.png" />
				</Link>

				<button
					type="button"
					className="menu_toggle"
					onClick={() => setIsOpen((current) => !current)}
					aria-label={isOpen ? "Cerrar menú" : "Abrir menú"}
					aria-expanded={isOpen}
				>
					{isOpen ? <FaTimes /> : <FaBars />}
				</button>

				<ul className="desktop_nav">
					{navItems.map((item) => (
						<Link
							key={item.page || "home"}
							to={item.url}
							className={actualPage === item.page ? "activeNav" : ""}
						>
							<li>
								{item.label}
								<hr />
							</li>
						</Link>
					))}
				</ul>

				<Link to="/contacto" className="contact_link">
					<Btn id="btnLogin">
						Contactar
					</Btn>
				</Link>
			</div>

			<AnimatePresence>
				{isOpen ? (
					<>
						<motion.div
							className="fondoNegro"
							onClick={closeMenu}
							initial={shouldReduceMotion ? false : { opacity: 0 }}
							animate={{ opacity: 0.38 }}
							exit={{ opacity: 0 }}
						/>
						<motion.div
							className="menuLateral"
							variants={shouldReduceMotion ? undefined : menuVariants}
							initial={shouldReduceMotion ? false : "hidden"}
							animate="visible"
							exit="exit"
						>
							<div className="mobile_menu_head">
								<img src="/images/logo-p-blanco.png" alt="ForzaKargo" />
								<button type="button" onClick={closeMenu} aria-label="Cerrar menú">
									<FaTimes />
								</button>
							</div>
							<ul>
								{navItems.map((item) => (
									<li key={item.page || "home"}>
										<Link
											to={item.url}
											onClick={closeMenu}
											className={actualPage === item.page ? "activeNav" : ""}
										>
											{item.label}
										</Link>
									</li>
								))}
								<li className="mobile_contact">
									<Link to="/contacto" onClick={closeMenu}>
										<Btn id="btnLoginMobile" type="btn_2">
											Contactar
										</Btn>
									</Link>
								</li>
							</ul>
						</motion.div>
					</>
				) : null}
			</AnimatePresence>
		</nav>
	);
};

export default Navbar;
